import { render, staticRenderFns } from "./Odontogram.vue?vue&type=template&id=09c61543&scoped=true"
import script from "./Odontogram.vue?vue&type=script&lang=js"
export * from "./Odontogram.vue?vue&type=script&lang=js"
import style0 from "./Odontogram.vue?vue&type=style&index=0&id=09c61543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c61543",
  null
  
)

export default component.exports